import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "../data/catalog";
import Logo from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-leduro-navy text-white">
      {/* Top CTA strip */}
      <div className="border-b border-white/10">
        <div className="leduro-container flex flex-col md:flex-row items-start md:items-center justify-between gap-6 py-10">
          <div>
            <p className="leduro-eyebrow text-leduro-orange">Project pricing</p>
            <h3 className="text-white text-2xl md:text-3xl font-heading font-bold mt-2 max-w-xl text-balance">
              Specifying 200+ luminaires? Get a tailored B2B quote within 24 hours.
            </h3>
          </div>
          <Link to="/where-to-find" data-testid="footer-cta-quote" className="leduro-btn-primary">
            Request a Quote
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="leduro-container grid grid-cols-1 md:grid-cols-12 gap-10 py-16">
        <div className="md:col-span-4">
          <Logo variant="white" />
          <p className="mt-6 text-white/70 text-sm leading-relaxed max-w-sm">
            Leduro supplies LED lighting and electrical goods to wholesalers, installers and facility managers across
            the Baltics and the European Union since 2008.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <div className="flex items-center gap-3 text-white/80">
              <MapPin className="h-4 w-4 text-leduro-orange" /> Krasta iela 105, Rīga, LV-1019, Latvia
            </div>
            <div className="flex items-center gap-3 text-white/80">
              <Phone className="h-4 w-4 text-leduro-orange" /> +371 67 000 000
            </div>
            <div className="flex items-center gap-3 text-white/80">
              <Mail className="h-4 w-4 text-leduro-orange" /> sales@leduro.eu
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="leduro-eyebrow text-leduro-orange">Catalogue</p>
          <ul className="mt-5 space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/catalogue/${c.slug}`}
                  data-testid={`footer-cat-${c.slug}`}
                  className="text-white/75 hover:text-leduro-orange transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="leduro-eyebrow text-leduro-orange">Company</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/about" data-testid="footer-link-about" className="text-white/75 hover:text-leduro-orange transition-colors">About Us</Link></li>
            <li><Link to="/useful-information" data-testid="footer-link-info" className="text-white/75 hover:text-leduro-orange transition-colors">Useful Information</Link></li>
            <li><Link to="/where-to-find" data-testid="footer-link-where" className="text-white/75 hover:text-leduro-orange transition-colors">Where to Find</Link></li>
            <li><Link to="/login" data-testid="footer-link-login" className="text-white/75 hover:text-leduro-orange transition-colors">Log in / Register</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="leduro-eyebrow text-leduro-orange">Trade newsletter</p>
          <p className="mt-5 text-sm text-white/70">
            New datasheets, project pricing and product launches — once a month, never spam.
          </p>
          <form
            className="mt-4 flex"
            onSubmit={(e) => {
              e.preventDefault();
              const btn = e.currentTarget.querySelector('[data-testid="newsletter-submit"]');
              if (btn) btn.textContent = "✓";
            }}
            data-testid="footer-newsletter-form"
          >
            <input
              type="email"
              required
              placeholder="you@company.com"
              data-testid="newsletter-email-input"
              className="flex-1 bg-white/5 border border-white/15 text-white placeholder-white/40 text-sm px-4 py-3 focus:outline-none focus:border-leduro-orange"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="bg-leduro-orange text-white font-bold text-xs uppercase tracking-wider px-5 hover:bg-leduro-orange-dark transition-colors"
            >
              Join
            </button>
          </form>
          <p className="mt-3 text-[11px] text-white/40">
            By subscribing you agree to receive trade communications from Leduro.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="leduro-container flex flex-col md:flex-row items-center justify-between gap-3 py-6 text-xs text-white/55">
          <span>© {new Date().getFullYear()} Leduro SIA · VAT LV40003000000 · All rights reserved.</span>
          <div className="flex items-center gap-6">
            <span>Privacy Policy</span>
            <span>Terms of Trade</span>
            <span>Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
